import { z } from 'zod'

/**
 * Media item, restricted to the parts the picker actually uses.
 *
 * `thumbnailUrl` is the smallest size we can find — WP returns sized
 * derivatives in `media_details.sizes`, but the dev site has them
 * disabled, so we fall back to the full `source_url`. The picker
 * uses CSS `object-cover` so size mismatch is cosmetic only.
 */
export const MediaSchema = z.object({
  id: z.number().int().positive(),
  title: z.string(),
  altText: z.string(),
  mimeType: z.string(),
  sourceUrl: z.string().url(),
  thumbnailUrl: z.string().url(),
  width: z.number().int().nonnegative().nullable(),
  height: z.number().int().nonnegative().nullable(),
})

export type Media = z.infer<typeof MediaSchema>
